import React from 'react'
import {FaExclamationTriangle} from 'react-icons/fa'
import Notice from '@components/V3/Notice'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

export default function PaymentNotReady() {
  const {order} = useOrder()
  const {t} = useTranslation('tracking', {keyPrefix: 'noPaymentWarning'})

  if (order.paymentStatus !== 'pending') return null
  if (!order.paymentGatewayUrl) return null

  return (
    <Notice level="warning" className="mt-6">
      <div className="flex items-center space-x-4">
        <FaExclamationTriangle size={18} />
        <div className="flex-1">
          {t('warning')}
          <div>
            <b>
              {t('clickToPayPre')}{' '}
              <a href={order.paymentGatewayUrl} className="!text-blue-600 !underline">
                {t('clickToPay')}
              </a>
            </b>
          </div>
        </div>
      </div>
    </Notice>
  )
}
